/**
 * Video metadata types
 */
export interface VideoMetadata {
  framerate?: string;
  [key: string]: unknown;
}

/**
 * Intercepts video metadata to unify frame rate handling.
 * If the frame rate is 59.94 (and not explicitly progressive),
 * it is changed to 29.97 to simplify application logic.
 *
 * @param metadata - The original video metadata.
 * @returns The modified video metadata.
 */
export function interceptFrameRate<T extends VideoMetadata | null | undefined>(metadata: T): T {
  if (!metadata || !metadata.framerate) {
    return metadata;
  }

  const newMeta = { ...metadata } as T & VideoMetadata;

  const framerateStr = String(newMeta.framerate);

  if (framerateStr.includes('59.94') && !framerateStr.includes('p')) {
    (newMeta as VideoMetadata).framerate = '29.97';
  }

  return newMeta;
}
